module.exports = __webpack_public_path__ + "static/logo-aapacn-2ce33e15d5ad7f42a4b729dc7ef8f22e.svg";